export default __webpack_public_path__ + "static/media/header.c4e0f333.png";